import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appLastUrlPath',
})
export class LastUrlPathPipe implements PipeTransform {

  /**
   * 
   * @param url la url total, generalmente router.url
   * @param pathToCheck el path final que quieres comprobar
   */
  transform(url: string, pathToCheck: string): boolean {
    const urlFilter = url.split('?')[0].split('/').pop();
    return pathToCheck === urlFilter;
  }

}
